export const ChainsInfo = {

    'Avalanche': {
        chainNameCapital: 'Avalanche',
        currencyName: 'AVAX',
        coingeckoName: 'avalanche-2',
        chainName: 'avalanche',
        chartsUri: 'https://zero-graph.0.exchange/subgraphs/name/zeroexchange/zerograph',
        blocksUri: 'https://zero-graph.0.exchange/subgraphs/name/zeroexchange/avalanche-blocks',
        factoryAddress: '0x2Ef422F30cdb7c5F1f7267AB5CF567A88974b308',
        bundleId: 1,
        wrappedCoinAddress: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
        blockExplorerUrl: 'https://cchain.explorer.avax.network/',
        nameExplorer: 'C-Chain Explorer'
    },
    'Smart_Chain': {
        chainNameCapital: 'Smart Chain',
        currencyName: 'BNB',
        coingeckoName: 'binancecoin',
        chainName: 'binance',
        chartsUri: 'https://api.thegraph.com/subgraphs/name/winter256/zerobscgraph3',
        blocksUri: 'https://api.thegraph.com/subgraphs/name/pancakeswap/blocks',
        factoryAddress: '0x52abdb3536a3a966056e096f2572b2755df26eac',
        bundleId: 1,
        wrappedCoinAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        blockExplorerUrl: 'https://bscscan.com/',
        nameExplorer: 'BscScan Explorer'
    },
    'Ethereum': {
        chainNameCapital: 'Ethereum',
        currencyName: 'ETH',
        coingeckoName: 'ethereum',
        chainName: 'ethereum',
        chartsUri: 'https://api.thegraph.com/subgraphs/name/winter256/zeroethgraph4',
        blocksUri: 'https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks',
        factoryAddress: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f',
        bundleId: 1,
        wrappedCoinAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        blockExplorerUrl: 'https://etherscan.io/',
        nameExplorer: 'EtherScan'
    }

}